export default Object.freeze({
  ADDITIVE: 'ADDITIVE',
  SUBTRACTIVE: 'SUBTRACTIVE'
})



// WEBPACK FOOTER //
// ./src/constants/add-devices/coverageRestrictionTypes.js